<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="newUsersPerDate" :options="newUsersPerDateReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { NEW_USERS_PER_DAY_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "NewUsersPerDate",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    gymBranch: {
      type: [Number, String],
    },
  },
  data() {
    return {
      newUsersPerDate: null,
    };
  },
  computed: {
    newUsersPerDateReport() {
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "New Users Per Day",
        },
        xAxis: {
          categories: this.newUsersPerDate.dateSeries.map((c) => c["actionDate"]),
        },
        yAxis: {
          title: {
            text: "% of users",
          },
        },
        series: [
          {
            name: "User Count",
            data: this.newUsersPerDate.dateSeries.map((c) => [c["actionDate"], parseInt(c["userCount"])]),
          },
        ],
      };
    },
  },
  apollo: {
    newUsersPerDate: {
      query: NEW_USERS_PER_DAY_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          gymBranch: this.gymBranch,
        };
      },
    },
  },
};
</script>
